import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { schoolInfo } from "../../mock/mock";

const useCountdown = (targetISO) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, new Date(targetISO).getTime() - now);
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60)
  };
};

const Countdown = () => {
  const c = useCountdown(schoolInfo.launchDateISO);

  const boxes = [
    { label: "Days", value: c.days },
    { label: "Hours", value: c.hours },
    { label: "Minutes", value: c.minutes },
    { label: "Seconds", value: c.seconds }
  ];

  return (
    <section className="py-16 relative overflow-hidden bg-gradient-to-br from-orange-100 via-amber-50 to-yellow-100">
      <div className="absolute inset-0 pattern-dots opacity-30" />
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
            <CalendarDays className="w-4 h-4 text-orange-600" />
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Countdown to Launch</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-2">
            Our Grand Launch on <span className="text-orange-600">1st January 2027</span>
          </h2>
          <p className="text-stone-600 max-w-xl mx-auto">Every second brings us closer to welcoming your little one into the Aadi Gayanam family.</p>
        </div>

        <div className="grid grid-cols-4 gap-3 md:gap-5 max-w-3xl mx-auto mb-8">
          {boxes.map((b) => (
            <div key={b.label} className="bg-white rounded-2xl md:rounded-3xl shadow-lg border border-orange-100 p-4 md:p-6 text-center">
              <p className="font-display font-bold text-3xl md:text-5xl bg-gradient-to-br from-orange-600 to-red-600 bg-clip-text text-transparent tabular-nums">
                {String(b.value).padStart(2, "0")}
              </p>
              <p className="text-[10px] md:text-xs uppercase tracking-widest text-stone-500 font-semibold mt-1">{b.label}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/admission">
            <Button size="lg" className="bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-full px-8 h-12 shadow-lg btn-shine">
              Secure Your Seat Early <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Countdown;
